import FeedbackIndex from './FeedbackIndex';
import FeedbackCreate from './FeedbackCreate';
import FeedbackSettings from './FeedbackSettings';
import FeedbackSingle from './FeedbackSingle';

export default function (app) {

    const settings = FeedbackSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    app.addMenu({
        key: settings.key,
        zone: settings.zone,
        label: settings.title,
        priority: 14,
        items: [
            {
                label: "All",
                path: settings.path,
                caps: settings.indexCaps
            },
            // {
            //     label: "Add New",
            //     path: settings.path + "/create",
            //     caps: settings.createCaps
            // }
        ],
    });

    FeedbackIndex(app, settings);

    FeedbackCreate(app, settings);

    FeedbackSingle(app, settings);

}